<template>
  <v-layout
    row
    wrap
    class="pa-4"
  >
    <v-flex xs12>
      <Toggle
        v-model="phoneScreen.otp_verification"
        title="OTP Verification"
        caption="OTP verification for new visitors"
        @change="_updateData('otp_verification', $event)"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import Toggle from '@/components/common/Toggle';

export default {
  name: 'PhoneScreen',
  components: {
    Toggle
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        otp_verification: true
      })
    }
  },
  data() {
    return {
      phoneScreen: {}
    };
  },
  watch: {
    data: {
      handler(val) {
        if (!val) return;
        this.phoneScreen = Object.assign({}, val);
      },
      immediate: true
    }
  },
  deactivated() {
    const validation = true;
    this.$emit('update', [this.phoneScreen, validation]);
  },
  methods: {
    _updateData(key, val) {
      this.phoneScreen[key] = val !== undefined ? val : null;
    }
  }
};
</script>

